// @ts-strict-ignore
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Company } from '../../crm/models/company.model';
import * as companyActions from '../actions/company.actions';
import { changeSortByListOrder } from '@fc-shared/utils/change-sort-by-list-order';
import { SortBy } from '@fc-shared/ui/sort-by/sort-by';

export interface State extends EntityState<Company> {
  selectedCompany: number;
  loadingMore: boolean;
  loading: boolean;
  companyError: any;
  total: number;
  companySearch: string;
  sortByList: SortBy[];
  sortBy: SortBy;
}

export const adapter: EntityAdapter<Company> = createEntityAdapter<Company>();

export const initialState: State = adapter.getInitialState({
  companySearch: '',
  sortBy: { name: 'Name', value: 'name', order: false },
  sortByList: [
    { name: 'Name', value: 'name', order: false },
    { name: 'Number of users', value: 'numbers', order: null },
  ],
  selectedCompany: null,
  loading: false,
  companyError: null,
  total: null,
  loadingMore: false,
});

export const reducer = createReducer(
  initialState,
  on(
    companyActions.loadCompany,
    companyActions.updateCompany,
    companyActions.addCompany,
    (state) => ({
      ...state,
      loading: true,
    }),
  ),
  on(companyActions.resetCompanyFilters, (state) => ({
    ...state,
    companySearch: initialState.companySearch,
    sortBy: initialState.sortBy,
    sortByList: initialState.sortByList,
  })),

  on(companyActions.cancelLoadCompanies, (state) => ({
    ...state,
    loading: false,
  })),
  on(companyActions.setCompanySearch, (state, action) => ({
    ...state,
    companySearch: action.search,
  })),
  on(companyActions.setCompanySort, (state, action) => ({
    ...state,
    sortBy: {
      ...action.sortBy,
      order: action.sortBy === null ? true : !action.sortBy.order,
    },
    sortByList: changeSortByListOrder(state.sortByList, action.sortBy),
  })),
  on(companyActions.addCompanySuccess, (state, action) => ({
    ...adapter.addOne(action.company, state),
    loading: false,
  })),
  on(companyActions.updateCompanySuccess, (state, action) => ({
    ...adapter.updateOne(action.company, state),
    loading: false,
  })),

  on(companyActions.deleteCompanySuccess, (state, action) => ({
    ...adapter.removeOne(action.id, state),
    selectedCompany: null as number,
  })),
  on(companyActions.loadCompanySuccess, (state, action) => ({
    ...adapter.addMany(action.company, state),
    loading: false,
  })),

  on(companyActions.loadMoreCompany, (state) => ({
    ...state,
    loadingMore: true,
  })),

  on(companyActions.loadMoreCompanySuccess, (state, action) => ({
    ...adapter.addMany(action.company, state),
    loadingMore: false,
  })),

  on(companyActions.companyError, (state, action) => ({
    ...state,
    companyError: action.err,
    loading: false,
  })),

  on(companyActions.ClearCompanies, (state) => adapter.removeAll(state)),

  on(companyActions.selectCompany, (state, action) => ({
    ...state,
    selectedCompany: action.id,
  })),
);

export const { selectIds, selectEntities, selectAll, selectTotal } =
  adapter.getSelectors();

export const getSelectedCompany = (state: State) => state.selectedCompany;
export const getCompanyLoading = (state: State) => state.loading;
export const getCompanyError = (state: State) => state.companyError;
export const getLoadingMore = (state: State) => state.loadingMore;
export const getCompanySearch = (state: State) => state.companySearch;
export const getCompanySort = (state: State) => state.sortBy;
export const getSortByList = (state: State) => state.sortByList;
